<div ngbAccordion>
  @for (event of events; track event) {
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton><div class="light-text me-2">{{ leagueLabel(event.league) }}</div>{{ event.event_name }}
        <app-countdown [eventClosed]="event.closed" [deadline]="event.deadline"></app-countdown>
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <img [src]="event.image_content"
            class="img-fluid rounded clickable"
            alt="Event Image"
            [routerLink]="['/home', 'events', event.league, event.uuid]">
            <span class="mt-3 card-text">{{ event.description }}</span>
          </ng-template>
        </div>
      </div>
    </div>
  }
</div>
